import { GetterTree } from 'vuex';
import { CalendarState } from './types';
import { RootState } from '@/vuex/types';
import { WeekDaysEvents, Location } from './types';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import { onlyUnique } from '@/utils/filters';
import { range } from 'lodash';

function getEventsByweekDays(calendarState: CalendarState): WeekDaysEvents[] {
    const events = calendarState.filteredEvents;
    const weekDaysIds = range(1, 8, 1);
    const allLocations = events
        .map((event: ICalendarData) => event.Address)
        .filter(onlyUnique)
        .sort();
    return weekDaysIds.map((weekDayId: number) => {
        const eventsInSingleDay = events.filter((event: ICalendarData) => event.WeekDayId === weekDayId);
        const eventsInLocations = allLocations.map((singleLocation: string) => {
            const eventsInSingleLocation = eventsInSingleDay.filter(
                (event: ICalendarData) => event.Address === singleLocation,
            );
            return { name: singleLocation, events: eventsInSingleLocation };
        });
        return { id: weekDayId, locations: eventsInLocations };
    });
}

function dayContainsEvents(weekDay: WeekDaysEvents) {
    const eventsNumber = weekDay.locations
        .map((x: Location) => x.events.length)
        .reduce((sum: number, x: number) => sum + x);
    return eventsNumber > 0;
}

export const getters: GetterTree<CalendarState, RootState> = {
    weekdaysContainerWidth(state) {
        return state.weekdaysContainerWidth;
    },
    weekdayContainerWidth(state) {
        return state.weekdayContainerWidth;
    },
    locationWidth(state) {
        return state.locationWidth;
    },
    boxWidth(state) {
        return state.boxWidth;
    },
    cellHeight(state) {
        return state.cellHeight;
    },
    boxType(state) {
        return state.boxType;
    },
    isMobile(state) {
        return state.isMobile;
    },
    getAllEvents(state) {
        return state.events;
    },
    getFilteredEvents(state) {
        return state.filteredEvents;
    },
    allHours(state) {
        return state.allHours;
    },
    hoursWithEvents(state) {
        return state.hoursWithEvents;
    },
    openedSingleActivityPopups(state) {
        return state.openedSingleActivityPopups;
    },
    getCalendarFilters(state) {
        return state.calendarFilters;
    },
    hiddenFilters(state) {
        return state.hiddenFilters;
    },
    eventsByWeekDays(state) {
        const eventsByWeekDays = getEventsByweekDays(state);
        return eventsByWeekDays.filter(
            (weekDay: WeekDaysEvents) => weekDay.locations.length && dayContainsEvents(weekDay),
        );
    },
};
